const SvgThumb = () => (
	<svg width="1em" height="1em" viewBox="0 0 26 27" fill="inherit" strokeWidth={2} xmlns="http://www.w3.org/2000/svg">
		<path d="M7.189 25.773H3.595c-1.318 0-2.397-1.105-2.397-2.455v-8.59c0-1.35 1.079-2.455 2.397-2.455h3.594m8.387-2.455V4.91c0-2.086-1.558-3.682-3.594-3.682L7.189 12.273v13.5h13.54c1.197 0 2.276-.86 2.396-2.087l1.677-11.045c.12-1.35-.719-2.577-2.037-2.823h-7.189Z" />
	</svg>
)

export default SvgThumb
